import { render, staticRenderFns } from "./CommCdTypeTable.vue?vue&type=template&id=65795e64&"
import script from "./CommCdTypeTable.vue?vue&type=script&lang=js&"
export * from "./CommCdTypeTable.vue?vue&type=script&lang=js&"
import style0 from "./CommCdTypeTable.vue?vue&type=style&index=0&id=65795e64&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports